import { Inject, Injectable, Optional, SkipSelf } from "@angular/core";

import { HttpClient } from "@angular/common/http";
import { Observable } from 'rxjs';

import { LignePlanMaintenanceTLR } from './ligne-plan-maintenance-tlr.entity';

@Injectable({ providedIn: 'root' })
export class LignePlanMaintenanceService {
	private path: string;

	constructor( //
		@Inject(HttpClient) private httpClient: HttpClient, //
		@Optional() @SkipSelf() previousInstance?: LignePlanMaintenanceService //
	) {
		if (previousInstance) {
			throw new Error(
				'This service is already loaded. Import it in the AppModule only');
		}
		this.path = (window as any).baseApiPath;
	}

	public getLignesByPlan(planId: number): Observable<LignePlanMaintenanceTLR[]> {
		let url = this.path + "plan-maintenance/" + planId + "/lignes?format=TLR";
		let result = this.httpClient //
			.get<LignePlanMaintenanceTLR[]>(url) //
		;

		return result;
	}
}